(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treezyn-20-yard-challenge"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.tyc');

    sections.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const intro = root.querySelector('[data-tyc-intro]');
      const game = root.querySelector('[data-tyc-game]');
      const result = root.querySelector('[data-tyc-result]');
      const scene = root.querySelector('[data-tyc-scene]');
      const deer = root.querySelector('[data-tyc-deer]');
      const vitals = root.querySelector('[data-tyc-vitals]');
      const reticle = root.querySelector('[data-tyc-reticle]');
      const impact = root.querySelector('[data-tyc-impact]');
      const action = root.querySelector('[data-tyc-action]');
      const promptTitle = root.querySelector('[data-tyc-prompt-title]');
      const promptCopy = root.querySelector('[data-tyc-prompt-copy]');
      const kicker = root.querySelector('[data-tyc-kicker]');
      const stageNumber = root.querySelector('[data-tyc-stage-number]');
      const progress = root.querySelector('[data-tyc-progress]');
      const scoreNode = root.querySelector('[data-tyc-score]');
      const distanceNode = root.querySelector('[data-tyc-distance]');
      const resultTitle = root.querySelector('[data-tyc-result-title]');
      const resultCopy = root.querySelector('[data-tyc-result-copy]');
      const form = root.querySelector('.tyc__form');
      const shopLink = root.querySelector('[data-tyc-shop]');
      const status = root.querySelector('[data-tyc-form-status]');

      const copy = {
        find: {
          kicker: kicker.textContent,
          title: promptTitle.textContent,
          body: promptCopy.textContent,
          button: action.textContent
        },
        stop: {
          kicker: root.dataset.stopKicker,
          title: root.dataset.stopHeading,
          body: root.dataset.stopCopy,
          button: root.dataset.stopButton
        },
        aim: {
          kicker: root.dataset.aimKicker,
          title: root.dataset.aimHeading,
          body: root.dataset.aimCopy,
          button: root.dataset.aimButton
        }
      };

      let stage = 'idle';
      let deerPosition = 8;
      let stopScore = 0;
      let aimFrame = 0;
      let deerFrame = 0;
      let startTime = 0;
      let currentReticle = { x: 0, y: 0 };

      const track = (eventName, details = {}) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, game_name: 'twenty_yard_challenge', ...details });
        root.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail: details }));
      };

      const show = (element) => { element.hidden = false; };
      const hide = (element) => { element.hidden = true; };

      const setPrompt = (name) => {
        const next = copy[name];
        kicker.textContent = next.kicker;
        promptTitle.textContent = next.title;
        promptCopy.textContent = next.body;
        action.textContent = next.button;
      };

      const setStage = (name, index) => {
        stage = name;
        stageNumber.textContent = `0${index} / 03`;
        progress.style.width = `${index * 33.333}%`;
        setPrompt(name);
      };

      const resetScene = () => {
        cancelAnimationFrame(deerFrame);
        cancelAnimationFrame(aimFrame);
        stage = 'idle';
        deerPosition = 8;
        stopScore = 0;
        deer.style.left = `${deerPosition}%`;
        deer.style.transform = 'translateX(-65%)';
        scene.classList.remove('is-aiming');
        impact.classList.remove('is-visible');
        reticle.style.left = '50%';
        reticle.style.top = '50%';
        setStage('find', 1);
      };

      const start = () => {
        resetScene();
        hide(intro);
        hide(result);
        show(game);
        startTime = performance.now();
        track('twenty_yard_start');
        action.focus({ preventScroll: true });
      };

      const beginDeerRun = () => {
        setStage('stop', 2);
        deerPosition = 6;
        const started = performance.now();

        const move = (now) => {
          if (stage !== 'stop') return;
          deerPosition = 6 + ((now - started) / 55) % 88;
          deer.style.left = `${deerPosition}%`;
          if (deerPosition > 92) {
            deerPosition = 6;
          }
          deerFrame = requestAnimationFrame(move);
        };

        deerFrame = requestAnimationFrame(move);
        track('twenty_yard_find');
      };

      const stopDeer = () => {
        cancelAnimationFrame(deerFrame);
        stopScore = Math.max(0, 100 - Math.abs(deerPosition - 52) * 2.5);
        deerPosition = Math.min(72, Math.max(30, deerPosition));
        deer.style.left = `${deerPosition}%`;
        setStage('aim', 3);
        scene.classList.add('is-aiming');
        track('twenty_yard_stop', { stop_score: Math.round(stopScore) });
        beginAim();
      };

      const targetPoint = () => {
        const sceneBox = scene.getBoundingClientRect();
        const targetBox = vitals.getBoundingClientRect();
        return {
          x: targetBox.left - sceneBox.left + targetBox.width / 2,
          y: targetBox.top - sceneBox.top + targetBox.height / 2
        };
      };

      const beginAim = () => {
        const started = performance.now();

        const move = (now) => {
          if (stage !== 'aim') return;
          const target = targetPoint();
          const elapsed = (now - started) / 1000;
          const pressure = Math.min(1.5, .72 + elapsed * .08);
          const x = target.x + Math.sin(elapsed * 4.7) * 47 * pressure + Math.sin(elapsed * 9.1) * 12;
          const y = target.y + Math.cos(elapsed * 3.9) * 34 * pressure + Math.sin(elapsed * 7.4) * 10;
          currentReticle = { x, y };
          reticle.style.left = `${x}px`;
          reticle.style.top = `${y}px`;
          aimFrame = requestAnimationFrame(move);
        };

        aimFrame = requestAnimationFrame(move);
      };

      const takeShot = () => {
        cancelAnimationFrame(aimFrame);
        stage = 'complete';
        const target = targetPoint();
        const distance = Math.hypot(currentReticle.x - target.x, currentReticle.y - target.y);
        const aimScore = Math.max(0, 100 - distance * 1.5);
        const score = Math.max(1, Math.min(99, Math.round(aimScore * .78 + stopScore * .22)));
        const yards = 20 + Math.floor(Math.random() * 9);

        impact.style.left = `${currentReticle.x}px`;
        impact.style.top = `${currentReticle.y}px`;
        impact.classList.add('is-visible');

        if (navigator.vibrate) navigator.vibrate(35);

        window.setTimeout(() => {
          hide(game);
          show(result);
          scoreNode.textContent = score;
          distanceNode.textContent = yards;

          if (score >= 78) {
            resultTitle.textContent = root.dataset.perfectTitle;
            resultCopy.textContent = root.dataset.perfectCopy;
          } else if (score >= 48) {
            resultTitle.textContent = root.dataset.goodTitle;
            resultCopy.textContent = root.dataset.goodCopy;
          } else {
            resultTitle.textContent = root.dataset.missTitle;
            resultCopy.textContent = root.dataset.missCopy;
          }

          track('twenty_yard_complete', {
            score,
            distance_yards: yards,
            duration_seconds: Math.round((performance.now() - startTime) / 1000)
          });
          resultTitle.focus?.({ preventScroll: true });
        }, 650);
      };

      root.querySelector('[data-tyc-start]').addEventListener('click', start);
      root.querySelector('[data-tyc-exit]').addEventListener('click', () => {
        resetScene();
        hide(game);
        hide(result);
        show(intro);
      });
      root.querySelector('[data-tyc-replay]').addEventListener('click', start);

      action.addEventListener('click', () => {
        if (stage === 'find') beginDeerRun();
        else if (stage === 'stop') stopDeer();
        else if (stage === 'aim') takeShot();
      });

      if (form) {
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const submitButton = form.querySelector('button[type="submit"]');
          submitButton.disabled = true;

          try {
            await fetch(form.action, {
              method: 'POST',
              body: new FormData(form),
              headers: { Accept: 'text/html' }
            });
          } catch (error) {
            track('twenty_yard_email_error');
          }

          form.querySelector('.tyc__form-row').hidden = true;
          status.hidden = false;
          shopLink.hidden = false;
          track('twenty_yard_email_submit');
          shopLink.focus({ preventScroll: true });
        });
      }

      if (shopLink) {
        shopLink.addEventListener('click', () => track('twenty_yard_reward_click'));
      }

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(root)) {
          cancelAnimationFrame(deerFrame);
          cancelAnimationFrame(aimFrame);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treezyn-deer-season-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const validSeasons = ['early', 'rut', 'late'];

    const automaticSeason = () => {
      const month = new Date().getMonth();
      if (month === 9 || month === 10) return 'rut';
      if (month === 11 || month === 0 || month === 1) return 'late';
      return 'early';
    };

    const initialize = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const buttons = Array.from(root.querySelectorAll('[data-season-button]'));
      const panels = Array.from(root.querySelectorAll('[data-season-panel]'));
      const heroes = Array.from(root.querySelectorAll('[data-season-hero]'));
      const details = Array.from(root.querySelectorAll('[data-season-detail]'));

      const track = (season) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'deer_season_filter', deer_season: season });
      };

      const paint = (season, updateUrl, shouldTrack) => {
        if (!validSeasons.includes(season)) return;

        const applyState = () => {
          buttons.forEach((button) => {
            const active = button.dataset.seasonButton === season;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-selected', active ? 'true' : 'false');
            button.tabIndex = active ? 0 : -1;
          });

          panels.forEach((panel) => {
            const active = panel.dataset.seasonPanel === season;
            panel.hidden = !active;
            panel.classList.toggle('is-active', active);
          });

          heroes.forEach((hero) => hero.classList.toggle('is-active', hero.dataset.seasonHero === season));
          details.forEach((detail) => detail.classList.toggle('is-active', detail.dataset.seasonDetail === season));
        };

        if (document.startViewTransition) document.startViewTransition(applyState);
        else applyState();

        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('season', season);
          window.history.pushState({ deerSeason: season }, '', url);
        }

        if (shouldTrack) track(season);
      };

      const params = new URLSearchParams(window.location.search);
      const requested = params.get('season');
      const configured = root.dataset.defaultSeason;
      let initial = validSeasons.includes(requested) ? requested : configured;
      if (initial === 'auto') initial = automaticSeason();
      if (!validSeasons.includes(initial)) initial = 'early';
      paint(initial, false, false);

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => paint(button.dataset.seasonButton, true, true));
        button.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const next = (index + direction + buttons.length) % buttons.length;
          buttons[next].focus();
          buttons[next].click();
        });
      });

      window.addEventListener('popstate', () => {
        const season = new URLSearchParams(window.location.search).get('season');
        paint(validSeasons.includes(season) ? season : automaticSeason(), false, false);
      });
    };

    document.querySelectorAll('.dhc').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.dhc').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tz-system-offer"]) return;
  try {
    
  if (!customElements.get('tz-system-offer')) {
    customElements.define('tz-system-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.config = JSON.parse(this.querySelector('[data-offer-config]').textContent);
        this.dialog = this.querySelector('dialog');
        this.select = this.querySelector('[data-offer-size]');
        this.button = this.querySelector('[data-offer-add]');
        this.error = this.querySelector('[data-offer-error]');
        this.root = window.Shopify?.routes?.root || '/';
        this.seen = new Set();
        this.busy = false;
        this.sequence = 0;
        this.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close(); } });
        this.dialog.addEventListener('close', () => { if (this.previousOverflow !== undefined) document.body.style.overflow = this.previousOverflow; if (this.restoreDrawer) this.drawer?.open(this.opener); else this.opener?.isConnected && this.opener.focus(); });
        this.select.addEventListener('change', () => this.updatePrice());
        this.querySelector('[data-offer-form]').addEventListener('submit', event => { event.preventDefault(); this.addOffer(); });
        this.onAdded = event => this.queue(event.detail);
        document.addEventListener('cart:updated', this.onAdded);
        const bind = () => {
          if (!this.isConnected) return;
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => { if (event?.source === 'product-form') this.queue(event.cartData); });
          try { const pending = JSON.parse(sessionStorage.getItem('tz-system-offer-pending') || 'null'); sessionStorage.removeItem('tz-system-offer-pending'); if (pending && Date.now() - pending.time < 20000) this.queue(pending.data); } catch (_) {}
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, {once:true}); else bind();
      }
      disconnectedCallback() { this.unsubscribe?.(); document.removeEventListener('cart:updated', this.onAdded); clearTimeout(this.timer); if (this.dialog?.open) { this.restoreDrawer = false; this.dialog.close(); } }
      productForAddition(data) {
        const added = Array.isArray(data?.items) ? data.items : [data];
        return this.config.products.find(product => added.some(item => item && (String(item.product_id) === String(product.id) || product.variants.some(v => String(v.id) === String(item.variant_id || item.id)))));
      }
      wasSeen(id) { try { return this.seen.has(id) || sessionStorage.getItem('tz-system-offer-seen-' + id) === '1'; } catch (_) { return this.seen.has(id); } }
      queue(data) {
        if (this.busy || this.dialog.open || !this.productForAddition(data)) return;
        const trigger = this.productForAddition(data);
        if (this.wasSeen(trigger.id)) return;
        try { sessionStorage.setItem('tz-system-offer-pending', JSON.stringify({data, time:Date.now()})); } catch (_) {}
        clearTimeout(this.timer);
        const sequence = ++this.sequence;
        this.timer = setTimeout(() => { try { sessionStorage.removeItem('tz-system-offer-pending'); } catch (_) {} this.consider(trigger, sequence); }, 500);
      }
      async cart() { const response = await fetch(this.root + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'}); if (!response.ok) throw new Error(this.config.labels.error); return response.json(); }
      eligible(cart, trigger, target) {
        return cart.currency === 'USD' && cart.items.some(i => String(i.product_id) === String(trigger.id)) && !cart.items.some(i => String(i.product_id) === String(target.id));
      }
      async consider(trigger, sequence) {
        try {
          const target = this.config.products.find(p => p.id !== trigger.id);
          const cart = await this.cart();
          if (sequence !== this.sequence || this.busy || this.dialog.open || this.wasSeen(trigger.id) || !this.eligible(cart, trigger, target)) return;
          const response = await fetch(this.root + 'products/' + encodeURIComponent(target.handle) + '.js', {headers:{Accept:'application/json'},cache:'no-store'});
          if (!response.ok) return;
          const fresh = await response.json();
          if (sequence !== this.sequence || !fresh.variants.some(v => v.available && v.price >= this.config.amount)) return;
          this.trigger = trigger;
          this.target = fresh;
          this.render();
          this.opener = document.activeElement;
          this.drawer = document.querySelector('cart-drawer');
          this.restoreDrawer = Boolean(this.drawer?.classList.contains('active'));
          if (this.restoreDrawer) this.drawer.close();
          this.previousOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          this.dialog.showModal();
          this.select.focus();
          this.seen.add(trigger.id);
          try { sessionStorage.setItem('tz-system-offer-seen-' + trigger.id, '1'); } catch (_) {}
        } catch (_) {}
      }
      money(value) { return new Intl.NumberFormat(this.config.locale || 'en-US', {style:'currency',currency:'USD'}).format(value / 100); }
      render() {
        this.querySelector('[data-offer-product-title]').textContent = this.target.title;
        const image = this.querySelector('[data-offer-image]');
        image.src = this.target.featured_image || this.target.images?.[0] || '';
        image.alt = this.target.title;
        this.select.replaceChildren();
        const placeholder = new Option(this.config.labels.choose, '');
        placeholder.disabled = true; placeholder.selected = true; this.select.add(placeholder);
        this.target.variants.forEach(variant => { const option = new Option(variant.title + (variant.available ? '' : ' — ' + this.config.labels.sold), String(variant.id)); option.disabled = !variant.available || variant.price < this.config.amount; this.select.add(option); });
        this.error.textContent = '';
        this.updatePrice();
      }
      updatePrice() {
        const selected = this.target.variants.find(v => String(v.id) === this.select.value);
        const variant = selected || this.target.variants.find(v => v.available && v.price >= this.config.amount);
        this.querySelector('[data-offer-regular]').textContent = this.money(variant.price);
        this.querySelector('[data-offer-price]').textContent = this.money(variant.price - this.config.amount);
        this.button.disabled = this.busy || !selected?.available || selected.price < this.config.amount;
      }
      async addOffer() {
        const variant = this.target?.variants.find(v => String(v.id) === this.select.value);
        if (this.busy || !variant?.available) return;
        this.busy = true; this.button.disabled = true; this.button.textContent = this.config.labels.adding; this.error.textContent = '';
        let added = false;
        try {
          const before = await this.cart();
          if (!this.eligible(before, this.trigger, this.target)) throw new Error(this.config.labels.changed);
          const drawer = document.querySelector('cart-drawer');
          const sections = drawer?.getSectionsToRender().map(s => s.id) || ['cart-icon-bubble'];
          const response = await fetch(this.root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}],sections,sections_url:location.pathname})});
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || this.config.labels.error);
          added = true;
          this.seen.add(this.target.id);
          try { sessionStorage.setItem('tz-system-offer-seen-' + this.target.id, '1'); } catch (_) {}
          this.restoreDrawer = false;
          this.dialog.close();
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source:'system-offer',cartData:data});
          if (drawer && sections.every(id => typeof data.sections?.[id] === 'string')) { drawer.classList.remove('is-empty'); drawer.renderContents(data); }
          else location.assign(this.root + 'cart');
        } catch (error) {
          if (added) location.assign(this.root + 'cart');
          else this.error.textContent = error.message || this.config.labels.error;
        } finally {
          this.busy = false; this.button.textContent = this.config.labels.add; this.updatePrice();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
